"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Tag = require("./Tag.styles");

var Tag = function Tag(props) {
  var className = props.className,
      label = props.label,
      color = props.color;
  return /*#__PURE__*/_react["default"].createElement(_Tag.StyledTag, {
    className: className,
    color: color
  }, /*#__PURE__*/_react["default"].createElement(_Tag.StyledLabel, {
    className: "tag-label"
  }, label));
};

Tag.defaultProps = {
  className: null,
  color: 'primary',
  label: null
};
Tag.propTypes = {
  /** The className of the tag */
  className: _propTypes.string,

  /** The color of the tag based on the theme */
  color: (0, _propTypes.oneOf)(['primary', 'secondary']),

  /** The tag label */
  label: _propTypes.string
};
Tag.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tag",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "The className of the tag",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "color": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "description": "The color of the tag based on the theme",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }]
      },
      "required": false
    },
    "label": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "The tag label",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Tag);

exports["default"] = _default;